import { render, staticRenderFns } from "./ClassroomMessages.vue?vue&type=template&id=51a3a682&scoped=true"
import script from "./ClassroomMessages.vue?vue&type=script&lang=js"
export * from "./ClassroomMessages.vue?vue&type=script&lang=js"
import style0 from "./ClassroomMessages.vue?vue&type=style&index=0&id=51a3a682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a3a682",
  null
  
)

export default component.exports